import { render, staticRenderFns } from "./CLPProductsList.vue?vue&type=template&id=36c6c5b5"
import script from "./CLPProductsList.vue?vue&type=script&lang=js"
export * from "./CLPProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports